import { ReactElement } from "react";
import {
  BrowserRouter,
  RouterProvider,
  UiMotionProvider,
} from "@rotorstudios/fe-modules";
import { UiProvider, useDeviceOS } from "@rotorstudios/fe-ui";
import { CAVProvider } from "@rotorstudios/configurable-asset-visualiser";
import { CMSProvider } from "@rotorstudios/fe-cms";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import {
  RCR_API_KEY_DEFAULT,
  RCR_ENDPOINT_DEFAULT,
} from "./_common/modules/configurable-asset-visualiser/config";
import {
  CMS_FIXVERSION_MANIFEST,
  DEFAULT_LANGUAGE,
  MAIN_CSS_CLASS_NAME,
} from "./_common/modules/Data/static";
import UiMUsabilla from "./_common/uiModules/uiMUsabilla/UiMUsabilla";
import { UsabillaProvider } from "./_common/uiModules/uiMUsabilla/useUiMUsabilla";
import { ThemeProvider } from "./_common/theme/ThemeProvider";
import { DataProvider } from "./_common/modules/Data/DataProvider";
import { CMEProvider } from "./_common/modules/fe-cme/CMEProvider";
import { BREAKPOINTS_CONFIG } from "./_common/modules/fe-ui/config";
import { ROUTES_DATA } from "./_common/modules/fe-modules/Router/routesData";
import { PAGE_HOME } from "./_common/modules/fe-modules/Router/static";
import UimLoadingSpinner from "./_common/uiComponents/molecules/uimLoadingSpinner/UimLoadingSpinner";
import Index from "../src/Pages/Index";
import { ConfiguratorProvider } from "./_common/contexts/ConfiguratorProvider";

const queryClient = new QueryClient();

const App = (): ReactElement => {
  const { isIOS } = useDeviceOS();

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={import.meta.env.VITE_APP_BASENAME}>
        <CMSProvider fixVersionUrl={CMS_FIXVERSION_MANIFEST} language={DEFAULT_LANGUAGE}>
          <DataProvider>
            <UsabillaProvider>
              <UiMUsabilla />
              <CMEProvider>
                <UiProvider
                  projectUrl={import.meta.env.VITE_PUBLIC_URL}
                  projectClass={MAIN_CSS_CLASS_NAME}
                  breakpointsConfig={BREAKPOINTS_CONFIG}
                >
                  <CAVProvider
                    isIOS={isIOS}
                    rcrEndpoint={RCR_ENDPOINT_DEFAULT}
                    rcrApiKey={RCR_API_KEY_DEFAULT}
                    loadingSpinner={
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          background: "#111111",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "absolute",
                        }}
                      >
                        <UimLoadingSpinner />
                      </div>
                    }
                  >
                    <UiMotionProvider>
                      <RouterProvider routesData={ROUTES_DATA} homePath={PAGE_HOME}>
                        <ConfiguratorProvider>
                          <ThemeProvider>
                            <Index />
                          </ThemeProvider>
                        </ConfiguratorProvider>
                        <ReactQueryDevtools initialIsOpen={false} />
                      </RouterProvider>
                    </UiMotionProvider>
                  </CAVProvider>
                </UiProvider>
              </CMEProvider>
            </UsabillaProvider>
          </DataProvider>
        </CMSProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};
export default App;
